import { render, staticRenderFns } from "./contract-device.vue?vue&type=template&id=030de18a&scoped=true"
import script from "./contract-device.vue?vue&type=script&lang=js"
export * from "./contract-device.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/style-review.css?vue&type=style&index=0&id=030de18a&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030de18a",
  null
  
)

export default component.exports